import { type RefObject, useEffect } from 'react'
import type { Scrollbars } from 'react-custom-scrollbars-2'
import { throttle } from 'lodash'

export const useMutationObserver = (scrollbarRef: RefObject<Scrollbars>) => {
  const handler = () => {
    scrollbarRef.current?.forceUpdate()
  }
  const throttleHandler = throttle(handler, 200, { trailing: false })

  useEffect(() => {
    const mutationObserver = new MutationObserver(() => {
      throttleHandler()
    })

    if (scrollbarRef.current?.container) {
      mutationObserver.observe(scrollbarRef.current?.container, {
        childList: true,
        subtree: true,
      })
    }

    return () => {
      mutationObserver.disconnect()
    }
  }, [])
}
